import React, { useEffect, useState } from 'react';
import BipComponenent from './Bip';
import Bip from '../../../controllers/bip';

const BipShortcut = (props) => {
    const { ModuleRP, locale, theme } = props;
    const [bipOpen, setBipOpen] = useState(false);
    const [bip] = useState(new Bip(ModuleRP.locale, ModuleRP.userName));
    const [, setForceRender] = useState(0);

    const forceUpdate = () => {
        setForceRender((prev) => prev + 1);
    };
    ModuleRP.Bip = bip;

    const calculatePosition = (isOpen) => {
        const zoomFactor = window.devicePixelRatio;
        const screenWidth = window.innerWidth / zoomFactor;
        const screenHeight = window.innerHeight / zoomFactor;

        if (isOpen) {
            return {
                x: screenWidth - 400,
                y: screenHeight / 1.5 - 250,
            };
        } else {
            return {
                x: screenWidth - 200,
                y: screenHeight - 100,
            };
        }
    };

    const [position, setPosition] = useState(calculatePosition(bipOpen));

    const openBip = () => {
        forceUpdate();
        setBipOpen((prev) => !prev);
        setPosition(calculatePosition(!bipOpen));
    };

    useEffect(() => {
        const handleResize = () => {
            setPosition(calculatePosition(bipOpen));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [bipOpen]);

    useEffect(() => {
        const update = () => {
            forceUpdate();
        };
        bip.addListener(update);

        return () => {
            bip.listeners = bip.listeners.filter((listener) => listener !== update);
        };
    }, [bip]);

    return (
        <div
            className="bip-shortcut"
            style={{
                position: 'fixed',
                left: position.x,
                top: position.y,
                backgroundColor: `${bip.messageOn || bip.alarmOn ? '#ff00007c' : '#e0e0e03f'}`,
                color: `${theme === 'DARK' ? 'white' : 'black'}`,
                padding: '10px',
                borderRadius: '5px',
                cursor: 'pointer',
                zIndex: 9999,
            }}
        >
            {bipOpen && <BipComponenent bip={bip} locale={locale} />}
            <span role="img" aria-label="bip" onClick={openBip}>
                📟 {bipOpen ? 'Fermer le bip' : 'Ouvrir le bip'}
            </span>
        </div>
    );
};

export default BipShortcut;
